import Breadcrumb from "component/common/breadcrumb";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  replySupportTicket,
  replySupportTicketRemove,
} from "reduxStore/action/raiseTicket(Support)Actions";
import strings from "translate/language";
import { handleDetailResponse, seo } from "utils/utils";

const EditReplyTicket = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const ticketId = new URLSearchParams(window.location.search).get("ticket_id");

  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const raiseTicketDetailSelector =
    useSelector((state) => state.raiseTicket) || {};

  const [form, setForm] = useState({
    status: "",
    remark: "",
  });

  useEffect(() => {
    const { response, updateTicketresponse = null } = raiseTicketDetailSelector;
    if (raiseTicketDetailSelector.response) {
      if (response?.status === 200) {
        setForm(handleDetailResponse(response?.data?.reply_support_ticket.filter(i => i._id === ticketId)));
      } else {
        setForm({});
      }
      if (updateTicketresponse && updateTicketresponse?.status === 200) {
        dispatch(replySupportTicketRemove());
        navigatpage(-1);
      }
    }
  }, [raiseTicketDetailSelector]);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };

  const editReplyTicket = () => {
    if (!handleValid()) {
      const post = {
        reply_support_ticket_id: ticketId,
        ticket_id: form.ticket_id,
        status: form.status,
        remark: form.remark,
      };
      dispatch(replySupportTicket(post));
    }
  };

  const handleValid = () => {
    let err = {};
    let formError = false;
    if (form.status === "") {
      formError = true;
      err["status"] = strings.statusErr;
    }
    if (!form.remark) {
      formError = true;
      err["remark"] = strings.remarkErr;
    }
    setFormVaild(err);
    return formError;
  };

  useEffect(() => {
    seo({
      title: "Edit Reply Ticket",
      metaDescription: "Edit reply ticket",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.editRaiseTicketReply}
        url={-1}
        parentListing={strings.viewsupportticketdetails}
        titleactive={strings.editRaiseTicketReply}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5>{strings.editRaiseTicketReply}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.selectStatus}
                          <span className="required-field"></span>
                        </label>
                        <select
                          className="form-control btn-square"
                          id="formcontrol-select1"
                          name="status"
                          value={form.status}
                          onChange={handleInputField}
                        >
                          <option value="">
                            {strings.selectstatus}
                          </option>
                          <option value={1}>{strings.open}</option>
                          <option value={2}>{strings.close}</option>
                        </select>
                        {formVaild.status && (
                          <span style={{ color: "red" }}>
                            {formVaild.status}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.description}
                          <span className="required-field"></span>
                        </label>
                        <textarea
                          className="form-control"
                          name="remark"
                          value={form.remark}
                          onChange={handleInputField}
                          id=""
                          cols="74"
                          rows="5"
                        ></textarea>
                        {formVaild.remark && (
                          <span style={{ color: "red" }}>
                            {formVaild.remark}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <button
                          className="btn btn-color"
                          type="button"
                          onClick={editReplyTicket}
                        >
                          {strings.edit}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>


            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditReplyTicket;
